/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-04 15:14:38
 *
 *******************************************************/
// @flow
/* eslint jsx-a11y/anchor-is-valid: 0 */
/* eslint no-script-url: 0 */

import _ from 'lodash';
import React, { Component } from 'react';
import productImage from 'src/assets/images/product/product-image.webp';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import { stringifyRGBA } from 'src/helpers/color-helper';

type Props = {
  settings: Object
};

type ComposedProps = Props & WithI18nProps;

class PreviewProduct extends Component<ComposedProps, State> {
  componentDidMount() {
    const { settings } = this.props;

    // Render preview content
    this.renderPreview(settings);
  }

  componentWillReceiveProps(nextProps) {
    const { settings } = nextProps;

    // Render preview content
    this.renderPreview(settings);
  }

  renderPreview = settings => {
    let {
      qvEnable,
      atcBtnBackgroundColor,
      atcBtnHoverBackgroundColor,
      atcBtnBorderColor,
      atcBtnHoverBorderColor,
      atcBtnTextColor,
      atcBtnHoverTextColor,
      atcEnable,
      qvBtnBackgroundColor,
      qvBtnHoverBackgroundColor,
      qvBtnBorderColor,
      qvBtnHoverBorderColor,
      qvBtnTextColor,
      qvBtnHoverTextColor
    } = settings.actionlist;

    if (_.isEmpty(settings)) return;
    try {
      if (atcEnable) {
        atcBtnBackgroundColor = this.parseColor(atcBtnBackgroundColor);
        atcBtnHoverBackgroundColor = this.parseColor(atcBtnHoverBackgroundColor);
        atcBtnBorderColor = this.parseColor(atcBtnBorderColor);
        atcBtnHoverBorderColor = this.parseColor(atcBtnHoverBorderColor);
        atcBtnTextColor = this.parseColor(atcBtnTextColor);
        atcBtnHoverTextColor = this.parseColor(atcBtnHoverTextColor);
        document.documentElement.style.setProperty('--bc-atc-btn-bg', atcBtnBackgroundColor);
        document.documentElement.style.setProperty(
          '--bc-atc-btn-bg-hover',
          atcBtnHoverBackgroundColor
        );
        document.documentElement.style.setProperty('--bc-atc-btn-color', atcBtnTextColor);
        document.documentElement.style.setProperty(
          '--bc-atc-btn-color-hover',
          atcBtnHoverTextColor
        );
        document.documentElement.style.setProperty('--bc-atc-btn-border', atcBtnBorderColor);
        document.documentElement.style.setProperty(
          '--bc-atc-btn-border-hover',
          atcBtnHoverBorderColor
        );
      }
      if (qvEnable) {
        qvBtnBackgroundColor = this.parseColor(qvBtnBackgroundColor);
        qvBtnHoverBackgroundColor = this.parseColor(qvBtnHoverBackgroundColor);
        qvBtnBorderColor = this.parseColor(qvBtnBorderColor);
        qvBtnHoverBorderColor = this.parseColor(qvBtnHoverBorderColor);
        qvBtnTextColor = this.parseColor(qvBtnTextColor);
        qvBtnHoverTextColor = this.parseColor(qvBtnHoverTextColor);

        document.documentElement.style.setProperty('--bc-qv-btn-bg', qvBtnBackgroundColor);
        document.documentElement.style.setProperty(
          '--bc-qv-btn-bg-hover',
          qvBtnHoverBackgroundColor
        );
        document.documentElement.style.setProperty('--bc-qv-btn-color', qvBtnTextColor);
        document.documentElement.style.setProperty('--bc-qv-btn-color-hover', qvBtnHoverTextColor);
        document.documentElement.style.setProperty('--bc-qv-btn-border', qvBtnBorderColor);
        document.documentElement.style.setProperty(
          '--bc-qv-btn-border-hover',
          qvBtnHoverBorderColor
        );
      }
    } catch (error) {
      console.log('Error: Render preview', error);
    }
  };

  render() {
    const { i18n } = this.props;
    let { qvEnable, atcEnable, alStyle } = this.props.settings.actionlist;
    const btnClassName = {
      'bc-al-style1': 'bc-atc-only-icon bc-qv-only-icon bc-al-bottom-v',
      'bc-al-style2': 'bc-atc-only-icon bc-qv-only-icon bc-al-bottom-h',
      'bc-al-style3': 'bc-atc-only-icon bc-qv-only-icon bc-al-bottom-h-full',
      'bc-al-style4': 'bc-atc-icon-text bc-qv-only-icon bc-al-bottom-h-full',
      'bc-al-style5': 'bc-atc-only-icon bc-qv-only-icon bc-al-middle',
      'bc-al-style6': 'bc-atc-only-text bc-qv-only-text bc-al-middle'
    };
    return (
      <div className="default-layout-settings item-center boost-pfs-filter-product-item-label-has-border">
        <div
          className={`boost-pfs-filter-product-item boost-pfs-action-list-enabled ${
            qvEnable && atcEnable ? '' : 'boost-pfs-hide-divider'
          } ${alStyle} ${btnClassName[alStyle]}`}>
          <div className="boost-pfs-filter-product-item-inner">
            <div className="boost-pfs-filter-product-item-image">
              <img
                src={productImage}
                className="boost-pfs-filter-product-item-main-image"
                align="product preview image"
                alt=""
              />
              <div className="boost-pfs-action-list-wrapper boost-pfs-action-extend">
                {atcEnable && (
                  <a href="javascript:;" className="boost-pfs-addtocart-wrapper">
                    <span className="boost-pfs-addtocart-btn boost-pfs-addtocart-select-options">
                      <span>
                        <svg width="40" height="40" viewBox="0 0 40 40">
                          <g id="boost-pfs-icon-cart" transform="scale(0.03125 0.03125)">
                            <path d="M448.217 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256s102.256-45.879 102.256-102.256c0-56.379-45.857-102.256-102.256-102.256zM448.217 977.908c-31.312 0-56.807-25.472-56.807-56.807 0-31.312 25.495-56.807 56.807-56.807s56.807 25.495 56.807 56.807c0.003 31.335-25.472 56.807-56.807 56.807z"></path>
                            <path d="M768.66 818.845c-56.377 0-102.256 45.902-102.256 102.256 0 56.377 45.879 102.256 102.256 102.256 56.354 0 102.256-45.879 102.256-102.256 0-56.379-45.902-102.256-102.256-102.256zM768.66 977.908c-31.335 0-56.807-25.472-56.807-56.807 0-31.312 25.472-56.807 56.807-56.807 31.29 0 56.807 25.495 56.807 56.807 0.003 31.335-25.517 56.807-56.807 56.807z"></path>
                            <path d="M1019.164 259.373c-4.294-5.499-10.886-8.702-17.883-8.702h-768.3l-63.329-233.255c-0.137-0.5-0.5-0.886-0.682-1.364-0.5-1.476-1.25-2.773-2.046-4.090-0.749-1.25-1.431-2.477-2.385-3.545-0.931-1.068-2.021-1.865-3.159-2.726-1.182-0.909-2.317-1.795-3.659-2.454-1.25-0.637-2.591-0.953-3.975-1.364-1.476-0.431-2.907-0.794-4.476-0.909-0.545-0.022-1.001-0.319-1.568-0.319h-124.978c-12.543 0-22.724 10.181-22.724 22.724s10.181 22.724 22.724 22.724h107.595l63.239 232.959 113.572 460.078c2.499 10.156 11.612 17.293 22.065 17.293h558.448c10.452 0 19.543-7.112 22.065-17.293l113.617-460.282c1.7-6.796 0.154-13.955-4.162-19.476zM869.871 710.976h-522.865l-102.39-414.858h727.667l-102.413 414.858z"></path>
                          </g>
                        </svg>
                        <span>
                          {i18n.translate(
                            'AdminHTML.DefaultLayoutSettings.Preview.actEnable_Children'
                          )}
                        </span>
                      </span>
                    </span>
                  </a>
                )}
                {qvEnable && (
                  <a href="javascript:;" className="boost-pfs-qv-wrapper">
                    <span className="boost-pfs-quickview-btn">
                      <span>
                        <svg width="40" height="40" viewBox="0 0 40 40">
                          <g id="boost-pfs-icon-quick-view" transform="scale(0.03125 0.03125)">
                            <path d="M1009.004 493.256c-2.256-2.82-56.254-69.828-143.786-137.492-51.696-39.962-104.462-71.87-156.832-94.834-66.48-29.152-132.556-43.932-196.386-43.932-63.832 0-129.904 14.782-196.386 43.932-52.37 22.962-105.136 54.87-156.834 94.834-87.53 67.666-141.528 134.674-143.784 137.494l-14.996 18.742 14.998 18.744c2.256 2.82 56.252 69.828 143.784 137.492 51.696 39.962 104.462 71.87 156.834 94.834 66.48 29.152 132.554 43.932 196.386 43.932 63.83 0 129.904-14.782 196.386-43.932 52.37-22.962 105.136-54.87 156.832-94.834 87.53-67.666 141.53-134.674 143.786-137.492l14.994-18.744-14.996-18.744zM827.402 621.624c-74.24 57.196-189.226 125.374-315.402 125.374-126.18 0-241.162-68.178-315.402-125.374-55.36-42.65-97.042-85.794-118.512-109.612 52.994-58.698 229.246-235.006 433.916-235.006 126.178 0 241.162 68.178 315.402 125.374 55.366 42.654 97.050 85.8 118.522 109.622-21.474 23.82-63.158 66.968-118.524 109.622z"></path>
                            <path d="M512 309.976c-111.396 0-202.024 90.63-202.024 202.024s90.63 202.024 202.024 202.024 202.026-90.628 202.026-202.024-90.63-202.024-202.026-202.024zM512 654.018c-78.308 0-142.018-63.71-142.018-142.018s63.71-142.018 142.018-142.018 142.018 63.71 142.018 142.018c0 78.308-63.71 142.018-142.018 142.018z"></path>
                            <path d="M512 419.322c-51.102 0-92.678 41.576-92.678 92.678s41.576 92.68 92.678 92.68 92.678-41.576 92.678-92.68c0-51.104-41.574-92.678-92.678-92.678zM512 544.672c-18.014 0-32.67-14.656-32.67-32.672s14.656-32.67 32.67-32.67 32.67 14.656 32.67 32.67c0.002 18.014-14.654 32.672-32.67 32.672z"></path>
                          </g>
                        </svg>
                        {i18n.translate(
                          'AdminHTML.DefaultLayoutSettings.Preview.qvEnable_Children'
                        )}
                      </span>
                    </span>
                  </a>
                )}
              </div>
            </div>
          </div>
          <div className="boost-pfs-filter-product-item-label">
            <span className="sale boost-pfs-filter-label">
              {i18n.translate('AdminHTML.DefaultLayoutSettings.Preview.saleLabel')}
            </span>
          </div>
          <div className="boost-pfs-filter-product-bottom">
            <a href="javascript:;" className="boost-pfs-filter-product-item-title">
              {i18n.translate('AdminHTML.DefaultLayoutSettings.Preview.productName')}
            </a>
            <p className="boost-pfs-filter-product-item-vendor">
              {i18n.translate('AdminHTML.DefaultLayoutSettings.Preview.category')}
            </p>
            <div className="boost-pfs-filter-product-item-price">
              <s>$71.50</s>
              {` `}
              <span className="boost-pfs-filter-product-item-sale-price">$41.50</span>
            </div>
          </div>
        </div>
      </div>
    );
  }

  parseColor(color) {
    if (_.has(color, 'rgb')) {
      color = stringifyRGBA(color.rgb);
    } else if (_.isString(color)) {
      color = color.replace(/\|\|/g, ', ');
    }

    return color;
  }
}

export default withI18n()(PreviewProduct);
